import React from "react";
import MaterialBox from "../../../../../components/MaterialBox";
import { FormControl, FormHelperText, Grid, Stack } from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialSelect from "../../../../../components/MaterialSelect";
import MaterialInput from "../../../../../components/MaterialInput";
import MultiSelectAutocomplete from "../../../../../components/MultiSelectAutocomplete";

const FirstComponent = ({
  handleChange,
  meetingData,
  projectNameOption,
  pages,
  handleMultipleSelect,
  masterData,
}) => {
  return (
    <div>
      <MaterialBox sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 3 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Meeting Project <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                value={meetingData?.meetingProject}
                name="meetingProject"
                onChange={handleChange}
                options={projectNameOption?.map((item) => {
                  return {
                    value: item?.id,
                    label: item?.project_name,
                  };
                })}
                error={meetingData.meetingProjectStatus === "error"}
                success={meetingData.meetingProjectStatus === "success"}
                isDisabled={pages.view}
              />

              {meetingData.meetingProjectStatus === "error" && (
                <FormControl error style={{ marginTop: "0px" }}>
                  <FormHelperText>
                    The employee name should contains only alphabets.
                  </FormHelperText>
                </FormControl>
              )}
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Meeting Title <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                value={meetingData?.meetingTitle}
                name="meetingTitle"
                placeholder="Enter Meeting Title"
                onChange={handleChange}
                error={meetingData.meetingTitleStatus === "error"}
                success={meetingData.meetingTitleStatus === "success"}
                disabled={pages.view}
              />
              {meetingData.meetingTitleStatus === "error" && (
                <FormControl error style={{ marginTop: "0px" }}>
                  <FormHelperText>
                    It allows only letters and spaces, with a length between 1
                    and 100 characters. Special characters are not
                    allowed.
                  </FormHelperText>
                </FormControl>
              )}
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Meeting Date <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                type="date"
                name="meetingDate"
                placeholder="Enter Employee Name"
                value={meetingData?.meetingDate}
                onChange={handleChange}
                error={meetingData.meetingDateStatus === "error"}
                success={meetingData.meetingDateStatus === "success"}
                disabled={pages.view}
              />
              {meetingData.meetingDateStatus === "error" && (
                <FormControl error style={{ marginTop: "0px" }}>
                  <FormHelperText>Enter the valid mail address.</FormHelperText>
                </FormControl>
              )}
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Meeting Start Time<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                type="time"
                name="meetingStartTime"
                placeholder="Enter Employee Name"
                value={meetingData?.meetingStartTime}
                onChange={handleChange}
                error={meetingData.meetingStartTimeStatus === "error"}
                success={meetingData.meetingStartTimeStatus === "success"}
                disabled={pages.view}
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Meeting End Time <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                type="time"
                name="meetingEndTime"
                placeholder="Enter Employee Name"
                value={meetingData?.meetingEndTime}
                onChange={handleChange}
                error={meetingData.meetingEndTimeStatus === "error"}
                success={meetingData.meetingEndTimeStatus === "success"}
                disabled={pages.view}
              />
            </Stack>
          </Grid>

          <Grid size={{ md: 4, xs: 12 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Participants
              </MaterialTypography>
              <MultiSelectAutocomplete
                name="participant"
                id="employee-selector"
                placeholder="Select Participants"
                options={masterData?.manager}
                value={meetingData?.participant}
                onChange={handleMultipleSelect}
                disabled={pages.view}
                labelKey="label"
              />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Stack direction="column" spacing={1}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Agenda <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                multiline
                rows={4}
                name="meetingAganta"
                placeholder="Add meeting agenda"
                value={meetingData?.meetingAganta}
                onChange={handleChange}
                error={meetingData.meetingAgantaStatus === "error"}
                success={meetingData.meetingAgantaStatus === "success"}
                disabled={pages.view}
              />
              {meetingData.meetingAgantaStatus === "error" && (
                <FormControl error style={{ marginTop: "0px" }}>
                  <FormHelperText>The meeting agenda should be less than 250 characters.</FormHelperText>
                </FormControl>
              )}
            </Stack>
          </Grid>
        </Grid>
      </MaterialBox>
    </div>
  );
};

export default FirstComponent;
